import api from './api';

export const roleService = {
  // Get all roles
  getAllRoles: async () => {
    const response = await api.get('/roles');
    return response.data;
  },

  // Get role by ID
  getRoleById: async (id) => {
    const response = await api.get(`/roles/${id}`);
    return response.data;
  },

  // Get role by name
  getRoleByName: async (name) => {
    const response = await api.get(`/roles/name/${name}`);
    return response.data;
  },

  // Create role
  createRole: async (roleData) => {
    const response = await api.post('/roles', roleData);
    return response.data;
  },

  // Update role
  updateRole: async (id, roleData) => {
    const response = await api.put(`/roles/${id}`, roleData);
    return response.data;
  },

  // Delete role
  deleteRole: async (id) => {
    const response = await api.delete(`/roles/${id}`);
    return response.data;
  },
}; 